module.exports = __webpack_public_path__ + "static/media/l_itdot_16.43cde7ef.png";